import { gql } from 'apollo-angular';

export const POPULAR_SUBJECTS = gql`
	query getPopularSubjects {
		popularSubjects {
			name
			courses_count
		}
	}
`;
